


































































































import Vue, {PropType} from 'vue'
import {api} from "@/ts/constants"
import {secondsToHms} from "@/ts/utils";
import {ILayoutMedia} from "@/ts/MediaInterfaces";
import {format} from "date-fns";

export default Vue.extend({
    name: 'GridPhoto',
    props: {
        layoutMedia: {type: Object as PropType<ILayoutMedia>, required: true},
    },
    data: () => ({
        api,
    }),
    methods: {
        updateIsSelecting() {
            this.delayedIsSelecting = this.$store.getters.isSelecting;
        },
        selectItem(e: MouseEvent) {
            this.$emit('selectItem', this.media, e.shiftKey);
        },
        playVideo() {
            let video = this.$refs.video as HTMLVideoElement;
            video?.play?.();
        },
        pauseVideo() {
            let video = this.$refs.video as HTMLVideoElement;
            video?.pause?.();
        },
        formatDate(date: number | Date, dateFormat: string) {
            if (typeof date === 'number')
                date = new Date(date);
            return format(date, dateFormat);
        },
        getThumbUrl(id: string, height: number) {
            let size = 'tiny';
            if (height > 260)
                size = 'small';
            if (height > 500)
                size = 'big';
            return `${api}/photo/${size}/${id}.webp`;
        },
        toHms(seconds: number) {
            return secondsToHms(seconds);
        },
    },
    computed: {
        selectionColor(): string {
            return this.themeColors.selectionColor;
        },
        delayedIsSelecting: {
            get(): boolean {
                return this.$store.state.delayedIsSelecting;
            },
            set(v: boolean) {
                this.$store.commit('delayedIsSelecting', v);
            },
        },
        isSelecting(): boolean {
            return this.$store.getters.isSelecting;
        },
        selected(): boolean {
            return this.$store.getters.isSelected(this.media.id);
        },
        themeColors(): { selectionColor: string } {
            let isDark = this.$vuetify.theme.dark;
            return this.$vuetify.theme.themes[isDark ? 'dark' : 'light'] as any;
        },
        media() {
            return this.layoutMedia.media;
        },
        currentPath() {
            let path = this.$route.path;
            if (path.endsWith('/'))
                return path.substr(0, path.length - 1)
            return path;
        },
    },
    watch: {},
})
